<template>
  <div>
    <van-sticky @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''">
<!--      <div class="box" >
        <div class="tab" @click="changeTabs('a')"><p>套餐充值</p><div class="tabsLine" :class="tabsName === 'a' ? '' : 'none'"></div></div>
      </div> -->
      <van-notice-bar
            class="subtle-notice"
            scrollable
          >
            💡 双击 ICCID 即可复制卡号
      </van-notice-bar>
      <van-cell size="large" class="glass-header">
        <template #title>
          <p @click="openTimeChanges('recharge')">
              查询日期：<van-icon name="notes-o"/>{{paramsList.endRechargeDate?paramsList.endRechargeDate:''}}
          </p>
          <div class="icon">
            <van-icon name="replay" @click="replay('recharge')" style="padding-right: 10px;" />
          </div>
        </template>
      </van-cell>
    </van-sticky>
    <van-tabs v-model='tabsName' >
      <van-tab name="a" title="充值订单">
        <!--日期选择-->
        <van-action-sheet v-model="orderDate.isSelect">
          <van-datetime-picker
            v-model="czCurrentDate"
            type="date"
            title="选择年月日"
            @confirm="getTime"
          />
        </van-action-sheet>
        <!--订单信息-->
        <VANABS :paramsList=paramsList @change = changeList :list="list"></VANABS>
        <div v-show="loadingShow" class="loading">
          <van-loading type="spinner" vertical>加载中...</van-loading>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import VANABS from '@/components/OrderVanTab'
import { saleOrder } from '@/api/Equipment.js'
export default {
  components: { VANABS },
  props: {},
  data () {
    return {
      // 充值查询时间
      orderDate: {
        isSelect: false
      },
      // 充值时间默认值
      czCurrentDate: new Date(),
      tabsName: 'a',
      stickyChangeFlag: false,
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0] + '',
        page: 1,
        limit: 10,
        endRechargeDate: ''
      },
      list: [],
      // list是否有数
      loadingShow: false,
      loadingShows: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    getTime (val) {
      window.scrollTo(0, 0)
      this.paramsList.page = 1
      this.paramsList.endRechargeDate = val.getFullYear() + '-' + (val.getMonth() < 9 ? '0' : '') + (val.getMonth() + 1) + '-' + val.getDate()

      this.orderDate.isSelect = false
      this.rechargeOrder()
    },
    async rechargeOrder () {
      this.loadingShow = true
      this.list = []
      const { data: res } = await saleOrder(this.paramsList)
      this.list = res.extend.rows
      if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      }
      this.$nextTick(_ => {
        this.loadingShow = false
      })
    },
    changeList (e) {
      if (e.type === 'add') {
        this.list.push(...e.list)
      } else {
        this.list = []
      }
    },
    changeTabs (e) {
      this.tabsName = e
      this.title = '充值'
    },
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    },
    // 重置时间查询
    replay (e) {
      const that = this
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否重置查询时间'
      }).then(async () => {
        window.scrollTo(0, 0)
        that.rechargeReplay()
        // on close
      }).catch(() => {
        this.$toast('取消重置')
      })
    },
    async rechargeReplay () {
      this.czCurrentDate = new Date()
      this.loadingShow = true
      this.list = []
      this.paramsList.endRechargeDate = ''
      this.paramsList.page = 1
      const { data: res } = await saleOrder(this.paramsList)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }

      this.list = res.extend.rows
      if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      }
      this.$nextTick(_ => {
        this.loadingShow = false
      })
    },
    openTimeChanges (e) {
      this.orderDate.isSelect = true
    }
  },
  beforeCreate () {},
  created () {
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  /deep/.van-cell__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      margin-left: 15px;
    }
    .icon {
      font-size: 36px;
      width: 100px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
  }
  /deep/.ve-table-body-tr,
  /deep/.ve-table-header-tr {
    height: 120px!important;
  }
  /deep/.ve-table-body-td,
  /deep/.ve-table-header-th {
    font-size: 25px!important;
  }
  /deep/.van-tabs__wrap {
    display: none;
    height: 0;
  }
  .ve-table {
    border-bottom: 1px solid #eeeeee;
  }
  .box {
    height: 100px;
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    .tab{
      text-align: center;
      font-size: 0.37333rem;
      line-height: 100px;
      position: relative;
      margin-left: 15px;
    }
    .tabsLine {
      position: absolute;
      bottom: 0.08rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      width: 1.06667rem;
      height: 0.08rem;
      background-color: #ee0a24;
    }
    .none {
      display: none;
    }
  }
  .stickyBottom {
    /deep/.van-sticky {
      border-bottom: 1px solid #f3f3f3;
    }
  }
  .noList {
    margin-top: 15px;
    text-align: center;
    .title {
      font-size: 30px;
      color: rgb(184, 184, 184);
    }
  }
  .loading {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 300%)
  }
  /* 假设这是你的顶部筛选栏或悬浮卡片的样式类 */
  .glass-header {
    padding-top: 10px;
    /* 1. 核心：背景模糊 (兼容性写法) */
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);

    /* 2. 关键：渐变背景 (从上到下，由实变虚) */
    /* 这里的 rgba 颜色建议取微信默认背景色 var(--weui-BG-0) 的近似值 */
    background: linear-gradient(
      to bottom,
      rgba(237, 237, 237, 1) 10%,   /* 顶部几乎不透明，保证文字清晰 */
      rgba(247, 247, 247, 0.9) 50%,  /* 中间开始变透 */
      rgba(247, 247, 247, 0.7) 90%,  /* 中间开始变透 */
      rgba(247, 247, 247, 0) 100%     /* 底部完全透明，自然融入列表 */
    );
    color: #55aaff;

    /* 3. 细节优化 */
    box-shadow: 0 1px 0 rgba(0,0,0,0.05); /* 加一条极淡的底边框代替阴影，更清爽 */
    z-index: 100; /* 确保在最上层 */
  }
  /* 适配深色模式 (Dark Mode) */
  @media (prefers-color-scheme: dark) {
    .glass-header {
      box-shadow: 0 1px 0 rgba(255,255,255,0.05);
    }
  }

  /* 极度压缩高度，淡化视觉注意力 */
  .subtle-notice {
    height: 26px;          /* 强制压缩高度，默认通常在 40px 左右 */
    padding: 0 10px;       /* 减少左右内边距 */
    font-size: 12px;       /* 缩小字体 */
    line-height: 26px;     /* 行高与高度保持一致，确保文字垂直居中 */
    background-color: #ededed; /* 使用极浅的灰色背景，或者直接设为 #fff 白色 */
    color: #969799;        /* 使用浅灰色字体，降低视觉冲击力 */
  }

  /* 深度选择器：覆盖 Vant 内部文字区域的默认样式 */
  .subtle-notice :deep(.van-notice-bar__wrap),
  .subtle-notice :deep(.van-notice-bar__content) {
    height: 26px;
    line-height: 26px;
  }

  /* 使用 :deep() 深度选择器穿透到 vant 组件内部 */
  :deep(.subtle-notice .van-notice-bar__content) {
    display: inline-block!important;
    white-space: nowrap!important;
    padding-left: 100%!important; /* 保持从右侧优雅滚入的开场效果 */
    /* 这里的 15s 是滚动一圈的总时长，你可以根据文字长短微调 */
    animation: smooth-marquee 5s linear infinite!important;
  }
  /* 定义跑马灯动画 */
  @keyframes subtle-notice {
    0% {
      transform: translateX(0); /* 初始位置在容器最右侧外部 */
    }
    100% {
      transform: translateX(-100%); /* 完整滚出左侧，实现无缝衔接 */
    }
  }
</style>
